// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__xNh0X","tab":"Tabs_tab__3iu5l","tabActive":"Tabs_tabActive__3YYvF"};